import { PartialGuide } from '../../lib/types/models/guide/guide'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getStaffGuides(id: number) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.getGuides.url, { id }))
    .get<PartialGuide[]>()
}
